import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../base/base.component';

@Component({
  selector: 'app-check-green-state',
  templateUrl: './check-green-state.component.html',
  styleUrls: ['./check-green-state.component.scss']
})
export class CheckGreenStateComponent extends BaseComponent implements OnInit {

  imggif:any;

  ngOnInit(): void {
    super.ngOnInit();
    this.imggif ='/assets/img/Foster-Animation-v05-01.gif?t=' + Date.now();

  	var router = this.router;
  	setTimeout(function(){
  		router.navigate(['/InfoPedidoComponent']);
  	}, 6000);
  }
}
